"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AGCurrentRefinements_styles_1 = __importDefault(require("./AGCurrentRefinements.styles"));
var react_instantsearch_dom_1 = require("react-instantsearch-dom");
var CurrentRefinements = function (_a) {
    var items = _a.items, refine = _a.refine;
    return (react_1.default.createElement(AGCurrentRefinements_styles_1.default, null,
        react_1.default.createElement("p", null, "Actieve filters:"),
        items.map(function (item) { return (item.items.map(function (nested) { return (react_1.default.createElement("a", { key: nested.label, href: "#", className: "filter", onClick: function (event) {
                event.preventDefault();
                refine(nested.value);
            } },
            react_1.default.createElement("span", null, nested.label),
            react_1.default.createElement("svg", { className: "icon", "aria-hidden": "true" },
                react_1.default.createElement("use", { xmlnsXlink: 'http://www.w3.org/1999/xlink', xlinkHref: '/dist/svg/sprite.min.svg#cross' })))); })); })));
};
var AGCurrentRefinements = react_instantsearch_dom_1.connectCurrentRefinements(CurrentRefinements);
exports.default = AGCurrentRefinements;
